import { render, staticRenderFns } from "./MenuLinkSummary.vue?vue&type=template&id=490f18a4"
import script from "./MenuLinkSummary.vue?vue&type=script&lang=ts"
export * from "./MenuLinkSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports